import { Treatment } from '../treat-image.directive'

export class GrayScaleTreatment implements Treatment {
  options: any;

  treat (image: HTMLImageElement, context: CanvasRenderingContext2D): ImageData {
    context.drawImage(image, 0, 0, image.width, image.height);

    const source = context.getImageData(0, 0, image.width, image.height);
    const result = context.createImageData(source.width, source.height);
    for (let i = 0; i < source.data.length; i += 4) {
      // tslint:disable-next-line:no-bitwise
      const luma = (11 * source.data[i] + 16 * source.data[i + 1] + 5 * source.data[i + 2]) >> 5;
      result.data[i] = result.data[i + 1] = result.data[i + 2] = luma;
      result.data[i + 3] = source.data[i + 3];
    }
    return result;
  }
}
